import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    setAction, resetAction
} from 'one-state-setsession/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
    FETCH_SET_SESSION = "one-state-setsession/fetch",
    GETSESSION_FETCH = "one-state-getsession/fetch"
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of Active Problems
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchSetSessionEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, log, agentId,agentMediaAddress,alertnotification, settings: {
            epicendpoints:{
                setsession,apitoken
            },
            servers,
            uisettings: {
                dashboardapiconfig: {
                    setsession : setsessionApi
                }
            },
            compatible : { consolidated_api_invocation, contact_center_type, finesse_proxy_service },
        }} = context;
        let participantadd = sessionStorage.getItem("participantAdd")
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.FETCH_SET_SESSION),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let payload: any = action.payload;
                let data = {}
                const postSetSession = (setsessionrequest: any) => {
                    if (setsessionrequest) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        if(contact_center_type === "vonage" || contact_center_type === "wxcc" || contact_center_type === "genesys" || contact_center_type === "ringcentral") {
                         data = {
                            "id":setsessionrequest.id,
                            "subjectID":setsessionrequest.subjectID,
                            "sourceID":setsessionrequest.sourceID
                         }

                        }
                        else if (contact_center_type === "twilio"|| contact_center_type === "inContact") {
                            data = {
                                "id": setsessionrequest.id,
                                "subjectID": setsessionrequest.subjectID,
                                "sourceID": setsessionrequest.sourceID
                            }

                        }

                        else if( contact_center_type === "finesse"|| contact_center_type === "five9") {
                            data = {
                                "subjectID":setsessionrequest.subjectID,
                                "sourceID":setsessionrequest.sourceID
                            }
                        }
                        let responseFromPost;
                        if (finesse_proxy_service) {
                            responseFromPost = InvokeFinesseProxy(setsession, data, apitoken, locations, log, 'POST', alertnotification);

                        } else { 
                            responseFromPost = server.post({
                                headers: headers,
                                path: setsession,
                                data: data,
                            })
                                .then((responseforap: any) => responseforap)
                                .catch((setsessionerror: any) => {
                                    log.error(
                                        "ccw-gadget,setsession-epic",
                                        "setsession-epic", {
                                            setsessionerror
                                    }
                                    );
                                    let errorbuild: ErrorObject={
                                        source:"SetSession",
                                        type:"error",
                                        status:setsessionerror?.status,
                                        erroritems:setsessionerror?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    return errorbuild;
                                })
                            log.debug(
                                "ccw-gadget,activeproblems-epic",
                                "activeproblems-epic response", {
                                    responseFromPost
                            });
                        }
                        return from(responseFromPost)
                    } else {
                        return from([]);
                    }
                }
                //Calling getReqeust function here
                //the reason is we need to use pipe function.
                if (!setsessionApi) return []
                return postSetSession(payload).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const getsessiondata = {
                                ani: payload.ani,
                                media_address:agentMediaAddress
                            }
                            let callType = sessionStorage.getItem("callType");
                            const actions:any =[
                                setAction(response.setsessionkey)
                            ];
                            // if(callType === "PREROUTE_ACD_IN") {
                            //     //do nothing
                            // }
                            // else {
                            // actions.push(pushToGetSession(getsessiondata))
                            // }
                            // if(response.error){
                            //     actions.push(addAction(response.error));
                            //     let disp: Disposition = { value: "1005" }
                            //     if (contact_center_type && contact_center_type === 'five9') {
                            //         let agentIdValue = sessionStorage.getItem("agentName");
                            //         disp.meta00 = agentIdValue;
                            //         disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            //     } else {
                            //         disp.meta00 = agentId;
                            //         disp.dial_list_uid = state$.value.choosecaller?.callId;
                            //     }
                            //     disp.meta01 = payload?.id;
                            //     disp.meta02 = response?.error?.status;
                            //     disp.meta03 = response?.error?.erroritems[0]?.error_detail;
                            //     disp.meta04 = 'client';
                            //     actions.push(pushToDisposition(disp));
                            // } else {
                            //     let disp: Disposition = { value: "188" }
                            //     if (contact_center_type && contact_center_type === 'five9') {
                            //         let agentIdValue = sessionStorage.getItem("agentName");
                            //         disp.meta00 = agentIdValue;
                            //         disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            //     } else {
                            //         disp.meta00 = agentId;
                            //         disp.dial_list_uid = state$.value.choosecaller?.callId;
                            //     }
                            //     disp.meta01 = payload?.id;
                            //     disp.meta02 = '200';
                            //     disp.meta03 = 'client';
                            //     actions.push(pushToDisposition(disp));
                            // }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * Listen for component clear and intiate state clear for Active Problems
 * @param context  contains logger which is used for logging
 */
export const clearSetSessionEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, setsessiom-epic",
            "clear-setsessiom-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED,PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);